import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {SetRatingComponent} from './set-rating.component';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';

@NgModule({
  declarations: [SetRatingComponent],
  imports: [
    IonicModule,
    CommonModule,
    TranslatePipe,
    TranslateDirective
  ],
  exports: [SetRatingComponent]
})
export class SetRatingModule {
}
